.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.searchContainer {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.header {
  align-items: flex-start;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.collapseToggle {
  flex-shrink: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.subtitleCollapsed {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.filters {
  align-items: start;
  display: grid;
  gap: var(--pgm-sys-spacing-4);
  grid-template-columns:
    minmax(0, 1fr)
    minmax(0, 0.5fr)
    minmax(0, 0.5fr)
    minmax(0, 0.75fr);
}

.nameField {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.nameHelper {
  color: var(--pgm-sys-color-on-surface-variant);
  padding: 0 16px;
}

.nameHelperError {
  color: var(--pgm-sys-color-error);
}

.searchButton {
  --md-filled-tonal-button-container-height: 56px;

  align-self: start;
  white-space: nowrap;
}

.emptyState,
.notice {
  box-sizing: border-box;
}

.emptyState {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-16) var(--pgm-sys-spacing-6);
  text-align: center;
}

.emptyIcon {
  color: var(--pgm-sys-color-on-surface-variant);
  font-size: 48px;
}

.emptyText {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  max-width: 720px;
  white-space: pre-line;
}

.results {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.resultsTitle {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.resultsGrid {
  display: grid;
  gap: var(--pgm-sys-spacing-4);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}

.resultCard {
  align-items: center;
  background-color: var(--pgm-sys-color-surface);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 12px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
  padding: 20px 20px 20px 24px;
  text-align: left;
  transition: box-shadow 0.15s ease;
  width: 100%;
}

.resultCard:hover,
.resultCard:focus-visible {
  box-shadow: var(--pgm-sys-elevation-level1);
}

.resultName {
  color: var(--pgm-sys-color-on-surface);
}

.resultView {
  align-items: center;
  color: var(--pgm-sys-color-primary);
  display: inline-flex;
  flex-shrink: 0;
  gap: var(--pgm-sys-spacing-2);
}

.resultViewIcon {
  font-size: 20px;
  line-height: 1;
}

.detail {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.detailHeader {
  align-items: center;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
}

.detailName {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.card {
  background-color: var(--pgm-sys-color-surface);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.cardTitle {
  align-items: center;
  color: var(--pgm-sys-color-secondary);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
}

.cardIcon {
  color: var(--pgm-sys-color-secondary);
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 500,
    "GRAD" 0,
    "opsz" 24;
  line-height: 24px;
}

.cardIconAids {
  color: var(--pgm-sys-color-secondary);
}

.values {
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.value {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.valueLabel {
  color: var(--pgm-sys-color-on-surface-variant);
}

.valueAmount {
  color: var(--pgm-sys-color-on-surface);
}

.legal {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  padding-top: var(--pgm-sys-spacing-4);
}

.legalTitle {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.legalText {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.notice {
  align-items: center;
  background-color: var(--pgm-sys-color-info-container);
  border-radius: 12px;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
  padding: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-6);
}

.noticeIcon {
  color: var(--pgm-sys-color-on-info-container);
  flex-shrink: 0;
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 500,
    "GRAD" 0,
    "opsz" 24;
  line-height: 24px;
}

.noticeText {
  color: var(--pgm-sys-color-on-info-container);
  margin: 0;
}

.portal {
  align-items: center;
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-1);
  margin: 0;
}

.portalLink {
  color: var(--pgm-sys-color-tertiary);
  text-decoration: underline;
}

.portalIcon {
  color: var(--pgm-sys-color-tertiary);
  font-size: 20px;
  line-height: 1;
}

@media (max-width: 1023.98px) {
  .filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .nameField,
  .searchButton {
    grid-column: 1 / -1;
  }

  .resultsGrid,
  .values {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 599.98px) {
  .filters {
    grid-template-columns: minmax(0, 1fr);
  }

  .periodSelect {
    grid-column: auto;
  }
}
